<div class="scan-doc-webcam">
  <div class="scan-doc-input-wrap" *ngIf="!showWebcam">
    <app-input class="mb_0 fullWidth"
               [type]="'file'"
               [formGrp]="inputForm"
               [formCtrlName]="'webcam_input'"
               [disabled]="disabled"
               [label]="labelKey | translate"
               [inputFileForceName]="hasValue ? (fileName || (labelKey + '_webcam_capture.jpg')) : null">
    </app-input>
    <button class="scan-doc-overlay"
            type="button"
            [disabled]="disabled"
            (click)="openCamera()">
    </button>
    <div class="head-button">
      <button class="scan-doc-camera-btn"
        type="button"
        [disabled]="disabled"
        (click)="openCamera()"
        title="Prendre une photo">
        <fa-icon [icon]="['fas','camera']" size="sm"></fa-icon>
      </button>
      <button class="scan-doc-upload-btn"
        type="button"
        [disabled]="disabled"
        (click)="$event.stopPropagation(); fileInput.click()">
        <fa-icon [icon]="['fas','upload']" size="sm"></fa-icon>
      </button>
      <button *ngIf="hasValue"
        class="scan-doc-delete-btn"
        type="button"
        [disabled]="disabled"
        (click)="onDeleteFile()"
        title="Supprimer le fichier">
        <fa-icon [icon]="['fas','times']" size="md" class="icon"></fa-icon>
      </button>
    </div>
    <input #fileInput type="file" accept=".png,.jpg,.jpeg,.pdf" style="display:none" (change)="onFileSelected($event)">
  </div>

  <app-webcam
    *ngIf="showWebcam"
    [fullHeight]="true"
    [enableBackUrl]="false"
    [documentCapture]="true"
    [canRotateCamera]="true"
    (output)="onCaptured($event)"
    (cameraProblem)="closeCamera()"
    (back)="closeCamera()"></app-webcam>
  <div *ngIf="showWebcam" class="webcam-capture-actions">
    <app-button color="red" size="xsm" (btnClicked)="closeCamera()">{{'global.cancel' | translate}}</app-button>
  </div>
</div>
